import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSafeText} from '../../utils/valueResolver';


function SupplyChainSection({ sections }) {
 const { t, i18n } = useTranslation();
  // セクションの初期開閉状態を `isOpen` プロパティに基づいて設定
  const initialOpenSections = sections.reduce((acc, section) => {
    acc[section.type] = section.isOpen || false; // `isOpen` が true の場合開く
    return acc;
  }, {});

  const [openSections, setOpenSections] = useState(initialOpenSections);

  // 指定されたセクションをトグルする関数
  const toggleSection = (type) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [type]: !prevState[type], // `type`に基づいてトグル
    }));
  };


  return (
    <div className="supplychain-section">
      {sections.map((section) => (
        <div key={section.type} className={`process-section ${section.type} ${openSections[section.type] ? 'open' : ''}`}>
          <div className="section-header" onClick={() => toggleSection(section.type)}>
            <div className="section-title">
              <span className="dot"></span>
              <span>{t(`supplyChain.${section.type}`)}</span>
            </div>
            <div className="icon-toggle"></div>
          </div>
          <div className="section-content">
            <div className="location-info">
              <span><span className="label">{t('supplyChain.location')}：</span><span className="value">{section.location}</span></span>
              <span><span className="label">{t('supplyChain.company')}：</span><span className="value">{section.company}</span></span>
            </div>
            {section.stepId !== 1 && (
            <div className="metrics-row">
              <div className="metrics-label">
                <img src="/images/icon/icon_energy.svg" alt="energy" />
                {t('supplyChain.energy')}
              </div>
              <div className="metrics-value">{section.energyConsumption}</div>
            </div>
            )}
          {section.stepId !== 1 && (
            <div className="metrics-row">
              <div className="metrics-label">
                <img src="/images/icon/icon_arrow_up.svg" alt="co2-emission" />
                 {t('supplyChain.co2Emission')}
              </div>
              <div className="metrics-value">{section.co2Emission}</div>
            </div>
            )}
            {section.co2Absorption && (
              <div className="metrics-row">
                <div className="metrics-label">
                  <img src="/images/icon/icon_arrow_down.svg" alt="co2-absorption" />
                 {t('supplyChain.co2Absorption')}
                </div>
                <div className="metrics-value">{section.co2Absorption}</div>
              </div>
            )}

{section.features?.length > 0 && section.features.some(f => f.effortDescription) && (
            <ul className="features-list">
            {section.features.map((f, idx) => (
<li key={idx} style={{ display: 'flex', alignItems: 'center' }}>
  {getSafeText(f.effortDescription)}
  {(f.effortUrl || f.referenceUrl) && (
    <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '6px' }}>
      {f.effortUrl && (
        <a
          href={f.effortUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', fontSize: '12px', color: '#666', textDecoration: 'none', marginRight: '6px',textDecoration: 'underline'}}
          title={f.effortUrl.includes('.pdf') ? t('supplyChain.viewPdf') : t('supplyChain.viewWeb')}
        >
          [

         {/*<img
            src={f.effortUrl.includes('.pdf') ? '/images/icon/icon_pdf.svg' : '/images/icon/icon_website.svg'}
            alt={f.effortUrl.includes('.pdf') ? 'PDF' : 'Web'}
            width="14"
            style={{ margin: '0 4px' ,filter: 'grayscale(10%) brightness(0.5)' // グレー＆控えめに
              }}
          />
          */}


          {f.effortUrl.includes('.pdf') ? 'PDF' : 'Web'}
          ]
        </a>
      )}
      {f.referenceUrl && (
        <a
          href={f.referenceUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', fontSize: '12px', color: '#666', textDecoration: 'none',textDecoration: 'underline'}}
          title={t('supplyChain.viewReference')}
        >
          [{t('supplyChain.reference')}]
        </a>
      )}
    </div>
  )}
</li>





))}
</ul>



)}


         

          </div>
        </div>
      ))}
    </div>
  );
}

export default SupplyChainSection;
